import { APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

export interface IGetRegisterGroup {
  id: number;
}

export interface IPostRegisterGroup {
  title: string;
  tipping_type: string;
  cellular: boolean;
  apps_on_device: boolean;
}

export interface IPutRegisterGroup {
  id: number;
  title: string;
  tipping_type: string;
  tip_percentage_low: number;
  tip_percentage_mid: number;
  tip_percentage_high: number;
  tip_fixed_amount_low: number;
  tip_fixed_amount_mid: number;
  tip_fixed_amount_high: number;
  cellular: boolean;
  apps_on_device: boolean;
}

export async function GetRegisterGroups(params?: IGetRegisterGroup, useGlobablLoader?: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/register/group"), params, useGlobablLoader, token);
}

export async function PostRegisterGroup(params: IPostRegisterGroup, useGlobablLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/register/group"), params, useGlobablLoader);
}

export async function PutRegisterGroup(params: IPutRegisterGroup, useGlobablLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/register/group"), params, useGlobablLoader);
}
